import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const Footer = ({ data, varient }) => {
  const { t } = useLanguage();
  const { openSettings } = useCookieConsent();
  const { logo, subTitle, bgImg } = data;
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const currentPosition = window.scrollY;
    setScrollPosition(currentPosition);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className={`st-site-footer st-sticky-footer st-dynamic-bg ${varient ? varient : ''}`}
      style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="st-main-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="st-footer-widget">
                <div className="st-text-field">
                  <img src={logo} alt="TerminTeiler Logo" className="st-footer-logo" />
                  <div className="st-height-b25 st-height-lg-b25" />
                  <div className="st-footer-text">{subTitle}</div>
                  <div className="st-height-b25 st-height-lg-b25" />
                  {/* <Social data={links} /> */}
                </div>
              </div>
            </div>
            {/* .col */}
            <div className="col-lg-4">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">{t('footer.legalLinks')}</h2>
                <ul className="st-footer-widget-nav st-mp0">
                  <li>
                    <Link to="/privacy-policy">{t('footer.links.privacyPolicy')}</Link>
                  </li>
                  <li>
                    <Link to="/cookie-policy">{t('footer.links.cookiePolicy')}</Link>
                  </li>
                  <li>
                    <Link to="/imprint">{t('footer.links.imprint')}</Link>
                  </li>
                  <li>
                    <Link to="/terms-conditions">{t('footer.links.termsConditions')}</Link>
                  </li>
                  <li>
                    <button
                      onClick={openSettings}
                      className="st-footer-link-btn"
                      aria-label={t('footer.links.cookieSettings')}
                    >
                      {t('footer.links.cookieSettings')}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            {/* .col */}
            <div className="col-lg-4">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">{t('footer.contacts')}</h2>
                <ul className="st-footer-contact-list st-mp0">
                  <li>
                    <span className="st-footer-contact-title">{t('footer.address')}</span> {t('footer.addressLine')}
                  </li>
                  <li>
                    <span className="st-footer-contact-title">{t('footer.email')}</span> support@terminteiler.com
                  </li>
                  <li>
                    <span className="st-footer-contact-title">{t('footer.phone')}</span> +49 152 38556881
                  </li>
                </ul>
              </div>
            </div>
            {/* .col */}
          </div>
        </div>
      </div>
      <div className="st-copyright-wrap">
        <div className="container">
          <div className="st-copyright-in">
            <div className="st-left-copyright">
              <div className="st-copyright-text">
                {t('footer.copyright').replace('{year}', currentYear)}
              </div>
            </div>
            <div className="st-right-copyright">
              <Link to="/privacy-policy" className="st-privacy-link">
                {t('footer.links.privacyPolicy')}
              </Link>
              <div id="st-backtotop" style={{ scale: `${scrollPosition >= 100 ? '1' : '0'}` }} onClick={scrollToTop}>
                <Icon icon="fa6-solid:angle-up" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;